import axios from 'axios'
import Config from '../Helpers/Config'
import {requiresRelogin}  from './authActions'

export const fetchProduct = (businessId, productId) => {
    return function (dispatch) {
        dispatch({
            type: 'FETCHING_SELL_PRODUCT'
        });
        return axios.get(`${Config.api()}product/find/${businessId}/${productId}`,{
            withCredentials:Config.withCredentials()
        })
            .then((response) => {
                if(response.status === 200){
                    dispatch({
                        type: 'FETCH_SELL_PRODUCT',
                        results: response.data
                    });
                }
            }).catch((error) => {
                if(error.response.status === 401){
                    dispatch(requiresRelogin(true,true))
                }else {
                    dispatch({
                        type: 'FETCHING_SELL_PRODUCT_FAILED'
                    });
                }
            });
    };
};

